<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20.85 22H3.15A1.16 1.16 0 012 20.85V3.15A1.16 1.16 0 013.15 2h17.7A1.16 1.16 0 0122 3.15v17.7A1.16 1.16 0 0120.85 22zM4 20h16V4H4z"/></svg>